import React from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import { DELETE_CONFIRMATION_DEFAULT } from 'chameleon/legacy/src/components/TeacherOrganize/utils/constants';

const DeleteLabelModal = ({
  onDelete,
  onCancel,
  label,
  confirmationMessage = DELETE_CONFIRMATION_DEFAULT,
  title = 'Delete Label',
  buttonType = 'danger',
}) => {
  const deleteLabel = () => {
    onDelete(label);
    onCancel();
  };
  return (
    <ConfirmDialog
      title={title}
      onSuccess={deleteLabel}
      onClose={onCancel}
      content={{
        btnPrimary: title.toLowerCase().includes('remove')
          ? 'Remove'
          : 'Delete',
        btnSecondary: 'Cancel',
        btnPrimaryType: buttonType,
      }}
    >
      <p className="margin-0 text-gray-700 font-normal text-16">
        {confirmationMessage}
      </p>
    </ConfirmDialog>
  );
};

// Prop types here are not final. Feel free to change/update
DeleteLabelModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  label: PropTypes.shape({
    labelId: PropTypes.string,
    name: PropTypes.string,
    masterSubjectId: PropTypes.number,
  }),
};

export default DeleteLabelModal;
